import { render, staticRenderFns } from "./IntroduceP.vue?vue&type=template&id=8d502598&scoped=true&"
import script from "./IntroduceP.vue?vue&type=script&lang=js&"
export * from "./IntroduceP.vue?vue&type=script&lang=js&"
import style0 from "./IntroduceP.vue?vue&type=style&index=0&id=8d502598&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d502598",
  null
  
)

export default component.exports